




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButtonDropdown from '@/modules/shared/components/shared/kit/BaseButtonDropdown.vue'
import { Prop } from 'vue-property-decorator'
import { ContentFormat } from '@/modules/content/models/content-resource.model'

@Component({
  inheritAttrs: false,
  components: { BaseButtonDropdown }
})
export default class ContentDownloadDropDown extends Vue {
  @Prop({ default: 'دانلود محتوا' }) label: string
  @Prop({ required: true }) route: string
  @Prop({ default: 'tes-gradient-blue' }) color: string
  @Prop() size: string
  @Prop({ default: () => [ContentFormat.HTML, ContentFormat.WORD, ContentFormat.PDF, ContentFormat.ZIP] }) formatList: string[]
  icons: Record<ContentFormat, string> = {
    [ContentFormat.HTML]: 'fal fa-file-code',
    [ContentFormat.WORD]: 'fal fa-file-word',
    [ContentFormat.PDF]: 'fal fa-file-pdf',
    [ContentFormat.ZIP]: 'fal fa-file-zipper'
  }

  getRoute(format) {
    const route = new URL(this.route)
    route.searchParams.append('format', format)
    return route
  }

}
